export default {"src":"/_next/static/media/avatar.28d1fac5.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};